import { styled } from '@mui/material/styles';

import bg from 'src/assets/images/bg.png';
import mobileBg from 'src/assets/images/mobileBg.png';
import purpleBlur from 'src/assets/images/purpleBlur.png';
import { device } from 'src/constants/muiSize';

export const Background = styled('div')({
  width: '100%',
  minHeight: '100vh',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  padding: '18rem 15rem 15rem',

  backgroundImage: `url(${purpleBlur}) ,url(${bg})`,
  backgroundSize: 'cover, cover',
  backgroundPosition: '50% 50%',

  overflow: 'auto',

  position: 'relative',
});

export const Scaffold = styled('div')(({ theme }) => ({
  width: '60rem',
  height: '75rem',

  padding: '4rem',

  borderRadius: '2rem',
  border: `1px solid ${theme.colors.base05}`,

  boxShadow: '0px 0px 2rem 0 rgba(255, 255, 255, 0.15)',

  backgroundColor: theme.colors.base07,

  position: 'relative',
}));

export const ContentsContainer = styled('div')({
  position: 'relative',
});

export const MediaColumnContainer = styled('div')({
  position: 'absolute',
  top: '0',
  right: '-48rem',

  [`@media ${device.macLaptop}`]: {
    right: '-25rem',
  },
});

export const MobileBackground = styled('div')({
  width: '100%',
  minHeight: '100vh',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  backgroundImage: `url(${mobileBg})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  overflow: 'auto',

  position: 'relative',
});

export const MobileScaffold = styled('div')({
  width: '100%',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  position: 'relative',
});

export const MobileComponent = styled('img')({
  width: '100%',
  height: 'auto',
  maxWidth: '40rem',
});

export const TabButtonContainer = styled('div')({
  width: '85%',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  marginBottom: '3rem',
  marginTop: '8rem',
});
